/* Easy Top product page v5. Runs once however many v5 sections load it.
   Videos: the poster and source are attached only when a clip comes near the screen, and a
   clip plays only while at least half of it is visible, so a phone never runs
   more than what is in view. Clips start muted (browsers only autoplay silent
   video); tap a clip or its speaker button to hear it from the start. One clip
   speaks at a time, and a clip goes quiet again when it leaves the screen. */
(function () {
  if (window.__ssv5) return;
  window.__ssv5 = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vids = [].slice.call(document.querySelectorAll('.ssv5 video[data-ssv5-src]'));

  /* Posters wait too, so nothing below the first screen competes with it. */
  function dress(v) { if (v.dataset.ssv5Poster && !v.poster) v.poster = v.dataset.ssv5Poster; }

  function load(v) {
    if (v.dataset.ssv5Loaded) return;
    v.dataset.ssv5Loaded = '1';
    v.src = v.dataset.ssv5Src;
  }
  function play(v) { if (reduce && v.muted) return; load(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  var ON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  var OFF = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="m22 9-6 6"/><path d="m16 9 6 6"/></svg>';
  function paint(v) {
    var b = v.ssv5Btn; if (!b) return;
    b.innerHTML = v.muted ? OFF : ON;
    b.setAttribute('aria-pressed', String(!v.muted));
    b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
  }
  function quiet(v) { if (!v.muted) { v.muted = true; paint(v); } }
  function toggleSound(v) {
    if (v.muted) {
      vids.forEach(function (o) { if (o !== v) quiet(o); });
      v.muted = false; v.volume = 1;
      try { v.currentTime = 0; } catch (e) {}
      paint(v); load(v); var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else { quiet(v); }
  }

  /* Each clip gets a speaker button in its corner; the clip itself also toggles sound. */
  vids.forEach(function (v) {
    v.muted = true;
    var wrap = document.createElement('span');
    wrap.className = 'ssv5__vwrap';
    v.parentNode.insertBefore(wrap, v);
    wrap.appendChild(v);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ssv5__sound';
    wrap.appendChild(b);
    v.ssv5Btn = b; paint(v);
    b.addEventListener('click', function (e) { e.preventDefault(); toggleSound(v); });
    v.addEventListener('click', function () { toggleSound(v); });
  });

  if ('IntersectionObserver' in window) {
    var near = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { dress(e.target); load(e.target); near.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    var seen = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.intersectionRatio >= 0.5) play(e.target);
        else { e.target.pause(); quiet(e.target); }
      });
    }, { threshold: [0, 0.5] });
    vids.forEach(function (v) { near.observe(v); seen.observe(v); });
  } else {
    vids.forEach(function (v) { dress(v); load(v); });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) vids.forEach(function (v) { v.pause(); quiet(v); });
  });

  /* Her day tabs */
  document.querySelectorAll('.ssv5__tabs').forEach(function (bar) {
    var root = bar.closest('.ssv5');
    bar.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ssv5-tab]'); if (!t) return;
      var i = t.getAttribute('data-ssv5-tab');
      bar.querySelectorAll('[data-ssv5-tab]').forEach(function (b) { var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', String(on)); });
      root.querySelectorAll('[data-ssv5-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-ssv5-pane') !== i; });
    });
  });

  /* Scroll to the buy box */
  function buyBox() {
    return document.querySelector('.kaching-bundles, [id^="MainProduct-"] .product-form__buttons, product-info variant-selects, .product__info-container');
  }
  function toBuy(jump) {
    var el = buyBox(); if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: reduce || jump ? 'auto' : 'smooth' });
  }
  /* Select the 3-top tier in the bundle widget, then bring her to it. */
  function pickSet(jump) {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    for (var i = 0; i < bars.length; i++) {
      var txt = (bars[i].textContent || '').toLowerCase();
      if (txt.indexOf('bra-free week set') > -1 || txt.indexOf('buy 3') > -1) {
        var r = bars[i].querySelector('input[type="radio"]'); (r || bars[i]).click(); break;
      }
    }
    toBuy(jump);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ssv5-to-buy]')) { e.preventDefault(); toBuy(false); }
    if (e.target.closest('[data-ssv5-pick-set]')) { e.preventDefault(); pickSet(false); }
  });

  /* Arriving from the home page's set button (#week-set): wait for the bundle
     widget to load, then pick the set. */
  if (location.hash === '#week-set') {
    var tries = 0;
    (function wait() {
      if (document.querySelector('.kaching-bundles__bar')) { pickSet(true); return; }
      if (++tries < 40) setTimeout(wait, 200);
    })();
  }
})();
